export const Machine = [
  {
    id: 1,
    title: "Sweet Bonanza",
    img: "img/slots/1.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 2,
    title: "Great Rhino",
    img: "img/slots/2.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 3,
    title: "Super Lion",
    img: "img/slots/16.png",
    desc: "",
    category: "Bonus",
    category1: "slots",
  },
  {
    id: 4,
    title: "Go Gold",
    img: "img/slots/17.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 5,
    title: "Big Top Bonanza",
    img: "img/slots/18.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 6,
    title: "Big Buffalo",
    img: "img/slots/19.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 7,
    title: "Respin Mania",
    img: "img/slots/20.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 8,
    title: "La Casa De Papel Clasico",
    img: "img/slots/21.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 9,
    title: "Nunchucks Chicken",
    img: "img/slots/22.png",
    desc: "",
    category: "New",
    category1: "slots",
  },
  {
    id: 10,
    title: "Wild Five",
    img: "img/slots/23.png",
    desc: "",
    category: "Bonus",
    category1: "slots",
  },
  {
    id: 11,
    title: "Wolf Gold",
    img: "img/slots/24.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 12,
    title: "The Dog House Megaways",
    img: "img/slots/25.png",
    desc: "",
    category: "Bonus",
    category1: "slots",
  },
  {
    id: 13,
    title: "John Hunter",
    img: "img/slots/26.png",
    desc: "",
    category: "Best",
    category1: "slots",
  },
  {
    id: 14,
    title: "The Dog House",
    img: "img/slots/27.png",
    desc: "",
    category: "Best",
    category1: "slots",
  },
  {
    id: 15,
    title: "Mustang Gold",
    img: "img/slots/28.png",
    desc: "",
    category: "Best",
    category1: "slots",
  },
  {
    id: 16,
    title: "Wild West",
    img: "img/slots/29.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 17,
    title: "John Hunter Book of Tut",
    img: "img/slots/30.png",
    desc: "",
    category: "Slots",
    category1: "slots",
  },
  {
    id: 18,
    title: "Sweet Bonanza Xmas",
    img: "img/slots/31.png",
    desc: "",
    category: "Best",
    category1: "slots",
  },
  {
    id: 19,
    title: "Virtual Futbol PRO",
    img: "img/slots/depor9.png",
    desc: "",
    category: "Best",
    category1: "deportes",
  },
  {
    id: 20,
    title: "Virtual Europa League",
    img: "img/slots/depor10.png",
    desc: "",
    category: "Deportivas",
    category1: "deportes",
  },
  {
    id: 21,
    title: "Virtual Generation",
    img: "img/slots/depor11.png",
    desc: "",
    category: "Best",
    category1: "deportes",
  },
  {
    id: 22,
    title: "Virtual World Cup",
    img: "img/slots/depor12.png",
    desc: "",
    category: "Deportivas",
    category1: "deportes",
  },
  {
    id: 23,
    title: "Virtual Champions",
    img: "img/slots/depor13.png",
    desc: "",
    category: "Bonus",
    category1: "deportes",
  },
  {
    id: 24,
    title: "Virtual Euro Legens",
    img: "img/slots/depor14.png",
    desc: "",
    category: "Deportivas",
    category1: "deportes",
  },
  {
    id: 25,
    title: "Virtual Soccer",
    img: "img/slots/depor15.png",
    desc: "",
    category: "Deportivas",
    category1: "deportes",
  },
  {
    id: 26,
    title: "Black Jack",
    img: "img/slots/online3.png",
    desc: "",
    category: "Bonus",
    category1: "online",
  },
  {
    id: 27,
    title: "Namaste Roulette",
    img: "img/slots/online4.png",
    desc: "",
    category: "Online",
    category1: "online",
  },
  {
    id: 28,
    title: "Lottery",
    img: "img/slots/online5.png",
    desc: "",
    category: "Online",
    category1: "online",
  },
  {
    id: 29,
    title: "Lucky 7",
    img: "img/slots/online6.png",
    desc: "",
    category: "Online",
    category1: "online",
  },
  {
    id: 30,
    title: "Roulette",
    img: "img/slots/online7.png",
    desc: "",
    category: "New",
    category1: "online",
  },
  {
    id: 31,
    title: "Bet On Teen Patti",
    img: "img/slots/online8.png",
    desc: "",
    category: "Other",
    category1: "online",
  },
];
export const TotalProducts = Machine.length;

export const Products = Machine.reduce((acc, product) => {
  if (!acc[product.category]) {
    acc[product.category] = [];
  }

  acc[product.category] = [...acc[product.category], product];

  return acc;
}, {});
